import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { HttpHeaders } from "./httpHeaders";
import { AbortError } from "@azure/abort-controller";
import { RestError } from "./restError";
/**
 * A HttpClient implementation that uses XMLHttpRequest to send HTTP requests.
 */

export var XhrHttpClient = /*#__PURE__*/function () {
  function XhrHttpClient() {
    _classCallCheck(this, XhrHttpClient);
  }

  _createClass(XhrHttpClient, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      var _a;

      var xhr = new XMLHttpRequest();

      if (request.proxySettings) {
        throw new Error("HTTP proxy is not supported in browser environment");
      }

      var abortSignal = request.abortSignal;

      if (abortSignal) {
        if (abortSignal.aborted) {
          return Promise.reject(new AbortError("The operation was aborted."));
        }

        var listener = function listener() {
          xhr.abort();
        };

        abortSignal.addEventListener("abort", listener);
        xhr.addEventListener("readystatechange", function () {
          if (xhr.readyState === XMLHttpRequest.DONE) {
            abortSignal.removeEventListener("abort", listener);
          }
        });
      }

      addProgressListener(xhr.upload, request.onUploadProgress);
      addProgressListener(xhr, request.onDownloadProgress);

      if (request.formData) {
        var formData = request.formData;
        var requestForm = new FormData();

        var appendFormValue = function appendFormValue(key, value) {
          if (value && Object.prototype.hasOwnProperty.call(value, "value") && Object.prototype.hasOwnProperty.call(value, "options")) {
            requestForm.append(key, value.value, value.options);
          } else {
            requestForm.append(key, value);
          }
        };

        for (var _i = 0, _Object$keys = Object.keys(formData); _i < _Object$keys.length; _i++) {
          var formKey = _Object$keys[_i];
          var formValue = formData[formKey];

          if (Array.isArray(formValue)) {
            for (var j = 0; j < formValue.length; j++) {
              appendFormValue(formKey, formValue[j]);
            }
          } else {
            appendFormValue(formKey, formValue);
          }
        }

        request.body = requestForm;
        request.formData = undefined;
        var contentType = request.headers.get("Content-Type");

        if (contentType && contentType.indexOf("multipart/form-data") !== -1) {
          // browser will automatically apply a suitable content-type header
          request.headers.remove("Content-Type");
        }
      }

      xhr.open(request.method, request.url);
      xhr.timeout = request.timeout;
      xhr.withCredentials = request.withCredentials;

      var _iterator = _createForOfIteratorHelper(request.headers.headersArray()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var header = _step.value;
          xhr.setRequestHeader(header.name, header.value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      xhr.responseType = ((_a = request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.size) || request.streamResponseBody ? "blob" : "text"; // tslint:disable-next-line:no-null-keyword

      xhr.send(request.body === undefined ? null : request.body);

      if (xhr.responseType === "blob") {
        return new Promise(function (resolve, reject) {
          handleBlobResponse(xhr, request, resolve, reject);
          rejectOnTerminalEvent(request, xhr, reject);
        });
      } else {
        return new Promise(function (resolve, reject) {
          xhr.addEventListener("load", function () {
            return resolve({
              request: request,
              status: xhr.status,
              headers: parseHeaders(xhr),
              bodyAsText: xhr.responseText
            });
          });
          rejectOnTerminalEvent(request, xhr, reject);
        });
      }
    }
  }]);

  return XhrHttpClient;
}();

function handleBlobResponse(xhr, request, res, rej) {
  xhr.addEventListener("readystatechange", function () {
    var _a; // Resolve as soon as headers are loaded


    if (xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
      if (request.streamResponseBody || ((_a = request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(xhr.status))) {
        var blobBody = new Promise(function (resolve, reject) {
          xhr.addEventListener("load", function () {
            resolve(xhr.response);
          });
          rejectOnTerminalEvent(request, xhr, reject);
        });
        res({
          request: request,
          status: xhr.status,
          headers: parseHeaders(xhr),
          blobBody: blobBody
        });
      } else {
        xhr.addEventListener("load", function () {
          // xhr.response is of Blob type if the request is sent with xhr.responseType === "blob"
          // but the status code is not one of the stream response status codes,
          // so treat it as text and convert from Blob to text
          if (xhr.response) {
            // Blob.text() is not supported in IE so using FileReader instead
            var reader = new FileReader();

            reader.onload = function (e) {
              var _a;

              var text = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
              res({
                request: request,
                status: xhr.status,
                headers: parseHeaders(xhr),
                bodyAsText: text
              });
            };

            reader.onerror = function (_e) {
              rej(reader.error);
            };

            reader.readAsText(xhr.response, "UTF-8");
          } else {
            res({
              request: request,
              status: xhr.status,
              headers: parseHeaders(xhr)
            });
          }
        });
      }
    }
  });
}

function addProgressListener(xhr, listener) {
  if (listener) {
    xhr.addEventListener("progress", function (rawEvent) {
      return listener({
        loadedBytes: rawEvent.loaded
      });
    });
  }
} // exported locally for testing


export function parseHeaders(xhr) {
  var responseHeaders = new HttpHeaders();
  var headerLines = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/);

  var _iterator2 = _createForOfIteratorHelper(headerLines),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var line = _step2.value;
      var index = line.indexOf(":");
      var headerName = line.slice(0, index);
      var headerValue = line.slice(index + 2);
      responseHeaders.set(headerName, headerValue);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return responseHeaders;
}

function rejectOnTerminalEvent(request, xhr, reject) {
  xhr.addEventListener("error", function () {
    return reject(new RestError("Failed to send request to ".concat(request.url), RestError.REQUEST_SEND_ERROR, undefined, request));
  });
  var abortError = new AbortError("The operation was aborted.");
  xhr.addEventListener("abort", function () {
    return reject(abortError);
  });
  xhr.addEventListener("timeout", function () {
    return reject(abortError);
  });
}